import { FormEvent, useState } from 'react';
import { api, ApiError } from '../../api';

interface Props {
  onNewAccount: () => void;
}

// Mühasib dəvəti: hesabı olan şəxsə login, e-poçt və ya telefonla (KT-63). Hesab yoxdursa yeni hesab yaratmaq təklif olunur.
export function InviteForm({ onNewAccount }: Props) {
  const [identifier, setIdentifier] = useState('');
  const [message, setMessage] = useState<string | null>(null);
  const [noAccount, setNoAccount] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    setMessage(null);
    setNoAccount(false);
    try {
      const r = await api.invite(identifier.trim());
      setMessage(`Dəvət göndərildi (${new Date(r.expiresAt).toLocaleDateString('az-AZ')}-dək). Şəxs girişdən sonra «Dəvətlər» bölməsində görəcək.`);
      setIdentifier('');
    } catch (err) {
      if (err instanceof ApiError && err.status === 404) setNoAccount(true);
      else setError(err instanceof ApiError ? err.message : 'Dəvət göndərilmədi');
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="product-form" onSubmit={submit} noValidate aria-label="Mühasib dəvəti">
      <h3>Mühasib dəvət et</h3>
      <label className="field">
        Login, e-poçt və ya telefon
        <input value={identifier} onChange={(e) => setIdentifier(e.target.value)} disabled={busy} autoComplete="off" />
      </label>
      {message && <p className="ok">{message}</p>}
      {noAccount && (
        <p className="muted">
          Bu məlumatla hesab tapılmadı.{' '}
          <button type="button" className="link-btn" onClick={onNewAccount}>
            Yeni mühasib hesabı yarat
          </button>
        </p>
      )}
      {error && (
        <p className="bad" role="alert">
          {error}
        </p>
      )}
      <div className="form-actions">
        <button type="submit" className="btn-primary" disabled={busy || identifier.trim() === ''}>
          {busy ? 'Göndərilir…' : 'Dəvət göndər'}
        </button>
      </div>
    </form>
  );
}
